"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Form = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _useContextSelector = require("use-context-selector");
var _ui = require("../../../../ui");
var _ModeTabsNav = require("../ModeTabsNav");
var _page = require("../page");
var _providers = require("../providers");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Form = function Form(_ref) {
  var children = _ref.children;
  var ticker = (0, _useContextSelector.useContextSelector)(_page.PageContext, function (state) {
    return state.ticker;
  });
  var history = (0, _reactRouterDom.useHistory)();
  var _useContext = (0, _react.useContext)(_providers.BalanceContext),
    useBalances = _useContext.useBalances;
  var _useBalances = useBalances(),
    getBalanceByTicker = _useBalances.getBalanceByTicker;
  var balance = getBalanceByTicker(ticker);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ModeTabsNav.ModeTabsNav, {
    activeTab: _ModeTabsNav.Mode.SEND,
    onTabChange: function onTabChange(mode) {
      if (mode === _ModeTabsNav.Mode.CONVERT) history.push('/send', {
        isExchange: true
      });
    }
  }), !balance ? /*#__PURE__*/_react.default.createElement(_ui.Spinner, {
    size: "lg",
    color: "primary"
  }) : children);
};
exports.Form = Form;